webpackJsonp([29],{

/***/ 637:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_detail02_vue__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03c1e6ce_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_detail02_vue__ = __webpack_require__(823);
var normalizeComponent = __webpack_require__(63)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_detail02_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03c1e6ce_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_detail02_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 822:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(228);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "help01",
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['news'])),
  mounted: function mounted() {
    this.getData();
  },

  methods: {
    getData: function getData() {
      this.$store.dispatch('getNewsList', { language: this.$i18n.locale });
    }
  }

});

/***/ }),

/***/ 823:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header other-banner other-banner-news",attrs:{"id":""}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"other-banner-title"},[_vm._v(_vm._s(_vm.$t('detail.NewsLetters')))])])]),_vm._v(" "),_c('div',{staticClass:"content bgf5f5f5"},[_c('div',[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"container sub-nav news-nav"},[_c('div',{staticClass:"col-md-12"},[_c('router-link',{staticClass:" ",attrs:{"to":"news"}},[_vm._v(_vm._s(_vm.$t('detail.RecentActivities')))]),_vm._v(" "),_c('router-link',{staticClass:" cur",attrs:{"to":"newsCompany"}},[_vm._v(_vm._s(_vm.$t('detail.CompanyNews')))])],1)]),_vm._v(" "),_c('div',{staticClass:"container col-jj"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"detail_con"},[_vm._l((_vm.news.newsData02),function(item,index){return (_vm.news.newsData02)?_c('div',[(item.newsCode + '' === _vm.$route.query.id)?_c('p',{domProps:{"innerHTML":_vm._s(item.newsSubject )}}):_vm._e()]):_c('div',[_vm._v("暂无数据")])}),_vm._v(" "),(_vm.news.newsData02&&_vm.news.newsData02.find(function (item){ return item.newsCode + '' === _vm.$route.query.id; })===undefined)?_c('p',[_vm._v(_vm._s(_vm.$t('global.empty')))]):_vm._e()],2)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// resource/js/29.1fd14fad87a28c5bd1db.js